import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});

const isDesktop = matchMedia('(min-width: 768px)').matches;
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnChange: isDesktop,
    addUrlParams: true
});

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as filterOverlay from './scripts/filter-overlay';
filterOverlay.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multipleSelectDropdown from './scripts/multiselect-dropdown';
multipleSelectDropdown.init();

import * as productExperience from './scripts/product-experience';
productExperience.init();

import * as smoothScroll from "@elements/smooth-scroll";
smoothScroll.init();

import * as affixHero from "@elements/affix";
onFind('.js-product-hero-affix', function (affix) {
    affix.dataset.affixOffset = matchMedia('(min-width:992px)').matches ? 100 : (100 / (991 / 100) * (window.innerWidth / 100));
});
affixHero.init({
    mediaQuery: '(min-width: 768px)'
},{
    base: '.js-product-hero-affix',
    placeholder: '.js-product-hero-affix__placeholder',
    container: '.js-product-hero-affix__container'
});

import * as affix from "@elements/affix";
affix.init();

import * as conditionalForm from './scripts/conditional-form';
conditionalForm.init();

import * as playVideo from './scripts/play-video';
playVideo.init();

import * as trackProductQuantity from './scripts/track-product-quantity';
trackProductQuantity.init();

import * as openModalOnPageload from './scripts/open-modal-on-pageload';
openModalOnPageload.init();